import React, { useState, useEffect } from "react";

export const svg = `<svg viewBox="0 0 28 28"><path xmlns="http://www.w3.org/2000/svg" fill="currentColor" d="m22.534 15.28-1.756 1.246 1.135.806a.208.208 0 0 1 0 .336l-.642.456 1.756 1.246.026-.018c1.263-.897 1.263-2.807 0-3.704l-.52-.368ZM7.222 16.526 5.466 15.28l-.52.369c-1.262.896-1.262 2.806 0 3.703l.027.018 1.756-1.246-.642-.456a.208.208 0 0 1 0-.336l1.135-.806Zm-.492 4.091 1.755-1.247 2.119 1.504-1.756 1.246-2.119-1.503Zm3.874 2.75 1.4.994c1.2.852 2.792.852 3.992 0l1.4-.994-1.755-1.247-.786.558a1.473 1.473 0 0 1-1.71 0l-.786-.558-1.755 1.247Zm6.792-2.493 1.756 1.246 2.119-1.503-1.756-1.247-2.119 1.504Z" opacity=".75"></path><path d="m5.057 8.101 7.566-4.708a2.608 2.608 0 0 1 2.754 0l7.566 4.708a2.234 2.234 0 0 1 0 3.798l-7.566 4.708a2.608 2.608 0 0 1-2.754 0l-7.566-4.708a2.234 2.234 0 0 1 0-3.798Z"></path></svg>`;

const contentRegExp = /<svg(.*?)>(.*?)<\/svg>/s;
const attrRegExp = /(.*?)="(.*?)"/;
const splitAttrExp = /[\w-]+="[^"]*"/g;

const attributeMap = {
  viewbox: "viewBox",
  class: "className",
};

let instanceId = 0;

function Icon(props) {
  const [, attrs, content] = svg.match(contentRegExp);

  const svgAttributes = {};

  for (const stringAttr of attrs.trim().match(splitAttrExp)) {
    let [, key, value] = stringAttr.match(attrRegExp);
    if (key in attributeMap) key = attributeMap[key];
    svgAttributes[key] = value;
  }

  const [obj, setObj] = useState({ svgAttributes, __html: content });

  // On the client, unique IDs are necessary per instance.
  // We will use the fact that React SSR does not run effects!
  useEffect(() => {
    const ids = svg.matchAll(/id="(.*?)"/gm);
    let html = obj.__html;

    for (const [match, id] of ids) {
      const uniqueID = `${id}-${instanceId}`;
      html = html
        .replace(match, 'id="' + uniqueID + '"')
        .replaceAll(`url(#${id})`, `url(#${uniqueID})`)
        .replaceAll(`"#${id}"`, `"#${uniqueID}"`);
    }

    setObj({ svgAttributes, __html: html });

    instanceId++;
  }, []);

  return (
    <svg
      dangerouslySetInnerHTML={obj}
      {...obj.svgAttributes}
      {...props}
    />
  );
}

export default Object.assign(Icon, { svg });
